module.exports = __webpack_public_path__ + "static/media/logs-empty.a60e3b43.svg";